export namespace goodsUtils {
  export interface PackagePlanDisplayInfo {
    title: string
    subtitle?: string
  }

  export function isPackagePricePlan(
    plan?: DataModels.goods.CourseMaterialPriceInfo
  ): boolean {
    return plan?.isPackage !== undefined || plan?.packageCode !== undefined
  }

  export function getPricePlanPackageCode(
    plan?: DataModels.goods.CourseMaterialPriceInfo
  ): string | undefined {
    return isPackagePricePlan(plan) ? plan?.packageCode : undefined
  }

  export function getPricePlanKey(plan: DataModels.goods.CourseMaterialPriceInfo): string {
    if (isPackagePricePlan(plan)) {
      return `${plan.goodsId}:package:${plan.packageCode ?? ''}`
    }

    return `${plan.goodsId}:goods`
  }

  export function getLastNonPackagePricePlanIndex(
    plans: DataModels.goods.CourseMaterialPriceInfo[]
  ): number {
    const lastIndex = plans.length - 1

    return lastIndex >= 0 && !isPackagePricePlan(plans[lastIndex]) ? lastIndex : -1
  }

  export function getPackagePlanDisplayInfo(
    plan: DataModels.goods.CourseMaterialPriceInfo
  ): PackagePlanDisplayInfo {
    const matchedName = plan.goodsName.match(/^(.+?)[（(](.+)[）)]$/)
    if (!matchedName) {
      return { title: plan.goodsName }
    }

    return {
      title: matchedName[1],
      subtitle: matchedName[2].replace(/\+/g, ' + '),
    }
  }
}
